import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Employee } from 'app/shared/types/employee';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { EmployeeService } from 'app/shared/services/employee.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';



@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css']
})
export class EmployeeComponent implements OnInit {

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;

  employee:Employee;
  employeeForm: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  validationMessages = {
    'empId': { 'required': 'Employee Id is required' },
    'empNo': { 'required': 'Employee number is required' }, 
    'empName': { 'required': 'First Name is required' },
    'phone': { 'required': 'Phone Number is required' },
    'email': {'email': 'Email must be a valid email address'},  
  };

  formErrors = {
    'empId': "",
    'empNo': "",
    'empName': "",
    'email': "",
    'phone': "",
  };

  constructor(private fb: FormBuilder,
              private employeeService: EmployeeService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private router : Router, 
              private themeService: NbThemeService,
              private fileUploadService:FileUploadService,
              private authService: AuthService
             ) { }

  ngOnInit() {

    this.employee = {
      id : null,
      empId : '',
      empNo : '',
      empName : '',
      fullName : '',
      nameWithInit : '',
      nic : '',
      dateOfBirth : '',
      permanentAddress : '',
      postalAddress : '',
      phone : '',
      email : '',    
      position : '',
      dateOfJoined : '', 
      status : '',
      createdBy : '',
  
    }


    this.employeeForm = this.fb.group({
      id : [null],
      empId : ['',Validators.required],
      empNo : ['',Validators.required],
      empName : ['',Validators.required],
      fullName : [''],
      nameWithInit: [''],
      nic : [''],
      dateOfBirth : [''],
      permanentAddress : [''],
      postalAddress : [''],
      phone : ['',Validators.required],
      email : ['',Validators.email],    
      position : [''],
      dateOfJoined : [''], 
      status : [''],
    });


  this.getDataTableRowData();
  this.getControlPermissions();
  this.themeService.onThemeChange()
  .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });

  }// end on init

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='EM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.employeeForm.value.empId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isSaveBtnDisabled = false;
    this.isShowAttachBtn=false; 
    this.enableForm();
    this.employeeForm.reset();
    this.resetValiationErrors();
    this.getMaxId();
    
   }


   getMaxId(){
    var empId = 0;
    var sEmpId : String;
  
    this.employeeService.getMaxId()
    .subscribe(
      (res) => {
                  empId = Number(res[0].MaxId) + 1;
                  sEmpId = empId.toString().padStart(3,'0');
                  this.employeeForm.patchValue({
                    empId : "EMP" + sEmpId
                  });
               

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }

  saveButtonClick(): void {
    var data : any;
    
    this.logValidationErrors(this.employeeForm,true);
    this.mapFormValuesToModel();  

          if(this.isFilledFromFields()){
            
              if(!this.employeeForm.value.id){
                this.showProcessingIndicator = true;
                this.employeeService.addEmployee(this.employee)
                .subscribe(
                  (res) => {                             
                              if(res.success === 0){
                                this.employeeForm.patchValue({
                                empId : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                data=res;
                                this.toastr.success('Employee was added successfully','Success');
                                this.isSaveBtnDisabled = true;     
                                this.isShowAttachBtn = true;                   
                                this.showProcessingIndicator = false; 
                             }   
                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add employee','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                    

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.employeeService.updateEmployee(this.employee.empId,this.employee)
            .subscribe(
              (res) => {
                          this.toastr.success('Employee was updated successfully','Success');
                          this.isSaveBtnDisabled = true;
                          this.showProcessingIndicator = false;  
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update employee','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

   enableForm(): void {
    Object.keys(this.employeeForm.controls).forEach(key => {
      this.employeeForm.controls[key].enable();
    });
  }
  
  
  resetValiationErrors(){
    Object.keys(this.employeeForm.controls).forEach(key => {
      this.employeeForm.get(key).setErrors(null) ;
    });
  }

  logValidationErrors(group: FormGroup = this.employeeForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      { 
        this.enableForm();
        this.employeeForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToModel(){
    this.employee.empId=this.employeeForm.value.empId
    this.employee.empNo=this.employeeForm.value.empNo;
    this.employee.empName=this.employeeForm.value.empName;
    this.employee.fullName=this.employeeForm.value.fullName;
    this.employee.nameWithInit=this.employeeForm.value.nameWithInit;
    this.employee.nic=this.employeeForm.value.nic;
    this.employee.dateOfBirth=moment(this.employeeForm.value.dateOfBirth).format("YYYY-MM-DD");
    this.employee.permanentAddress=this.employeeForm.value.permanentAddress;
    this.employee.postalAddress=this.employeeForm.value.postalAddress;
    this.employee.phone=this.employeeForm.value.phone;
    this.employee.email=this.employeeForm.value.email;
    this.employee.position=this.employeeForm.value.position;
    this.employee.dateOfJoined=moment(this.employeeForm.value.dateOfJoined).format("YYYY-MM-DD");
    if(this.employeeForm.value.status){
      this.employee.status='Deactivated';    
    }
    else{
      this.employee.status='Active';
    }  
    this.employee.createdBy=this.authService.getUserLoggedIn();

  }

 

  


activeStatus = false;
viewEmployee(employee:any){

  if(employee.Status=='Active'){
    this.activeStatus = false;
  }else{
    this.activeStatus = true;
  }
 
  this.employeeForm.patchValue({  
    id            :employee.Id,
    empId         :employee.EmpId,
    empNo         :employee.EmpNo,
    empName      : employee.EmpName,
    fullName  : employee.FullName,
    nameWithInit       : employee.NameWithInitials,
    nic           : employee.NIC,
    dateOfBirth   : employee.DateOfBirth,
    permanentAddress : employee.PermanentAddress,
    postalAddress  : employee.PostalAddresss,
    phone          : employee.PhoneNo,
    email          : employee.Email,
    position       : employee.Positon,
    dateOfJoined   :employee.DateOfJoined,
    status         : this.activeStatus,    
   
  });

  this.isShowAttachBtn = true;

}

getDataTableRowData(){
  var data = this.employeeService.dataRow;
  if(data){
    this.viewEmployee(data);
  }else{
    this.newButtonClick();
  }


}


}